(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/app/betslipv2/assets/javascripts/betslip.js') >= 0) return;  svs.modules.push('/components/app/betslipv2/assets/javascripts/betslip.js');


'use strict';

svs = svs || {};
svs.app = svs.app || {};
svs.app.betslipv2 = svs.app.betslipv2 || {};
svs.app.betslipv2.Betslip = Marionette.View.extend({
  template: function(data) {
    return svs.app.betslipv2.templates.betslip(data);
  },

  templateContext: function() {
    return {
      relativeLayout: this.options && this.options.relativeLayout || false
    };
  },

  id: 'betslip',
  className: 'betslip',

  events: {
    'click .betslip-overlay': 'toggleOpen',
    'click .betslip-footer': 'toggleOpen',
    'click .betslip-header': 'toggleOpen',
    'click .betslip-footer-tag': 'toggleOpen',
    'click .betslip-footer-border-override': 'toggleOpen',
    'click .betslip-selfservice-touch-area': 'toggleOpen',
    'keyup .betslip-footer': 'keyup'
  },

  regions: {
    betslipContent: '.betslip-content',
    betslipFooter: '.betslip-footer',
    betslipHeader: '.betslip-header'
  },

  swiperOptions: {
    scrollbars: false,
    scrollingX: false,
    scrollingY: true
  },

  swiper: null,

  betslipContentWrapper: null,

  betslipNotificationEl: null,

  relativeLayout: false,

  betslipHeaderHeight: 31,

  animationSpeed: 200,

  showActionbar: false,

  recycle: false,

  model: new Backbone.Model({ isValid: true }),

  initialize: function(options) {
    var self = this;
    this.overload = options;

    if (options.dontManipulateDOM === undefined) {
      options.dontManipulateDOM = false;
    }

    this.doResize = _.debounce(function() {
      self.setHeight();
      self.changeSize();
    }, 100);

    $(window).on('resize', this.doResize);

    _.bindAll(this, 'setHeight', 'changeSize');

    if (this.overload.options && this.overload.options.model) {
      this.model = this.overload.options.model;
      if (!this.overload.options.hideValidationError) {
        this.listenTo(this.model, 'change:isValid', this.revalidateBetslip);
      }
    }

    this.listenTo(this.getRegion('betslipContent'), 'show', function() {
      if (self.getRegion('betslipContent').currentView) {
        self
          .getRegion('betslipContent')
          .currentView.on('changesize', self.changeSize);
      }
    });

    this.listenTo(this.getRegion('betslipContent'), 'destroy', function() {
      if (
        self.getRegion('betslipContent') &&
        self.getRegion('betslipContent').currentView
      ) {
        self.getRegion('betslipContent').currentView.off('changesize');
      }
    });

    if (svs.core.detect.formfactor.mobile()) {
      this.listenTo(this.getRegion('betslipFooter'), 'show', function() {
        _.defer(function() {
          self.setWrapperPadding();
        });
      });
    }

    this.listenTo(this.getRegion('betslipFooter'), 'destroy', function() {
      _.defer(function() {
        $('.js-main-content').css('padding-bottom', '');
      });
    });

    this.listenTo(this.model, 'change:isValid', this.revalidateBetslip);

    if (this.options.relativeLayout) {
      this.addRegion('betslipPaymentArea', '.js-betslip-payment-area');
      this.addRegion('betslipPayOptions', '.js-betslip-pay-options');
      this.addRegion('betslipPay', '.js-betslip-pay');
      this.$el.addClass('betslip-relative-layout');
    }
  },

  onBeforeShowBetslipContent: function(view) {
    if (svs.core.detect.formfactor.mobile()) {
      var actionbar = $('#actionbar-content');

      if (actionbar.is(':visible')) {
        actionbar.hide();
        this.showActionbar = true;
      }
    }

    if (!this.options.dontManipulateDOM && view) {
      this.getRegion('betslipContent').$el.html(view.el);
    }
  },

  onRender: function() {
    var self = this;

    this.delegateEvents();
    if (this.options.relativeLayout) {
      this.delegateEvents({
        'click .betslip-overview': 'showOverview'
      });
    }

    this.setHeight();

    this.betslipContentWrapper = this.$el.find('.betslip-content-wrapper');
    this.betslipNotificationEl = this.$el.find('.js-betslip-notification');

    if (svs.syndicate && svs.syndicate.AccountSelector) {
      var syndicate = svs.syndicate.AccountSelector.getAccountModel();
      if (syndicate.isSyndicateActive() && location.search === '') {
        svs.syndicate.AccountSelector.setQueryString(syndicate.get('syndicateId'));
      }
    }

    this.getRegion('betslipContent').onBeforeShow = this.onBeforeShowBetslipContent.bind(this);
    this.getRegion('betslipContent').onShow = function(view) {
      var betslipContent = this;
      var elementsMax;
      var contentHeight;
      var contentWidth;
      var dynamicHeight;
      elementsMax = parseInt($(this.$el[0]).css('max-height'), 10);
      contentHeight = view.$el[0].clientHeight;
      contentWidth = view.$el[0].clientWidth;
      dynamicHeight =
        contentHeight > elementsMax ? elementsMax : contentHeight;

      self.betslipContentWrapper.css(
        'top',
        dynamicHeight + self.betslipHeaderHeight
      );

      betslipContent.$el.css('height', dynamicHeight);

      var swiper = new svs.components.Swiper();
      self.swiper = swiper.init(
        betslipContent.$el.get(0),
        self.swiperOptions
      );

      self.swiper.updateDimensions(contentWidth, contentHeight);

      self.trigger('betslipOpened');

      if (svs.syndicate && svs.syndicate.AccountSelector) {
        self.showChildView(
          'betslipHeader',
          new svs.app.betslipv2.Betslip.BetslipHeader({
            model: svs.syndicate.AccountSelector.getAccountModel()
          })
        );
      } else if (
        svs.components.marketplace &&
        svs.components.marketplace.accountSelector &&
        svs.components.marketplace.accountSelector.helpers.observer.getValue()
          .accounts.length > 0
      ) {
        self.showBetSlipHeaderMarketPlace();
      } else {
        self.showChildView(
          'betslipHeader',
          new svs.app.betslipv2.Betslip.BetslipHeader()
        );
      }

      self.betslipContentWrapper.animate(
        { top: 0, useTranslate3d: true },
        this.animationSpeed,
        'easeOut'
      );
    };
    if (this.options.storeState) {
      svs.components.Storage.browser.get(
        this.options.storeState.type + 'betslipstate',
        this.options.storeState.product,
        function(data) {
          if (
            data &&
            self.options.storeState.validOpenState &&
            self.getRegion('betslipContent')
          ) {
            self.openBetslip();
          }
        }
      );
    }
  },

  initBetSlipHeaderMarketPlace: function() {
    var selectedAcc = svs.components.marketplace.accountSelector.helpers.getCurrentAccount();
    if (selectedAcc) {
      this.showChildView(
        'betslipHeader',
        new svs.app.betslipv2.Betslip.BetslipHeader({
          model: new Backbone.Model({
            playableAmount: selectedAcc.balance,
            syndicateName: selectedAcc.name,
            syndicateId: selectedAcc.groupId,
            displayAccount: selectedAcc.name !== 'user',
            isSyndicate: true,
            isMarketPlace: true
          })
        })
      );
    } else {
      this.showChildView(
        'betslipHeader',
        new svs.app.betslipv2.Betslip.BetslipHeader()
      );
    }
  },

  showBetSlipHeaderMarketPlace: function() {
    if (
      svs.components.marketplace.accountSelector.helpers.getCurrentAccount()
    ) {
      this.initBetSlipHeaderMarketPlace();
    }

    this.initBetSlipHeaderMarketPlace = this.initBetSlipHeaderMarketPlace.bind(this);
    svs.components.marketplace.accountSelector.helpers.observer.subscribe(this.initBetSlipHeaderMarketPlace);
  },

  afterBetslipContentShow: function() {
    var view = $('#betslip-content')
      .children()
      .first();
    if (view.length === 0) {
      return;
    }

    if (view.hasClass('swiper-container')) {
      view = $(view[0]).children();
    }

    var contentHeight; var dynamicHeight; var elementsMax;

    elementsMax = parseInt($('#betslip-content').css('max-height'), 10);
    contentHeight = view[0].clientHeight;
    dynamicHeight = contentHeight > elementsMax ? elementsMax : contentHeight;

    this.betslipContentWrapper.css(
      'top',
      dynamicHeight + this.betslipHeaderHeight
    );

    $('#betslip-content').css('height', dynamicHeight);

    this.trigger('betslipOpened');

    if (svs.syndicate && svs.syndicate.AccountSelector) {
      this.showChildView(
        'betslipHeader',
        new svs.app.betslipv2.Betslip.BetslipHeader({
          model: svs.syndicate.AccountSelector.getAccountModel()
        })
      );
    } else if (
      svs.components.marketplace &&
      svs.components.marketplace.accountSelector &&
      svs.components.marketplace.accountSelector.helpers.observer.getValue()
        .accounts.length > 0
    ) {
      this.showBetSlipHeaderMarketPlace();
    } else {
      this.showChildView(
        'betslipHeader',
        new svs.app.betslipv2.Betslip.BetslipHeader()
      );
    }
    this.betslipContentWrapper.animate(
      { top: 0, useTranslate3d: true },
      this.animationSpeed,
      'easeOut'
    );
  },

  onDestroy: function() {
    $('.js-main-content').css('padding-bottom', '');
    $(window).off('resize', this.doResize);
    if (this.options.relativeLayout) {
      if (svs.core.detect.formfactor.mobile()) {
        $(window).off('scroll', this.onScrollBind);
      } else if (this.overload.swiperContainer) {
        $(this.overload.swiperContainer[0]).off(
          'scroll',
          this.onScrollBind
        );
      }
    }
    if (
      svs.components.marketplace &&
      svs.components.marketplace.accountSelector
    ) {
      svs.components.marketplace.accountSelector.helpers.observer.unsubscribe(this.initBetSlipHeaderMarketPlace);
    }
  },

  keyup: function(e) {
    if (e.currentTarget === e.target) {
      if (e.keyCode === 13 || e.keyCode === 32) {
        this.openBetslip();
      } else if (e.keyCode === 27) {
        this.closeBetslip();
        svs.events.publish('/betslip/close');
      }
    }
  },

  toggleOpen: function(e) {
    e.preventDefault();

    var target = $(e.target);

    if (
      target.hasClass('js-betslip-help') ||
      target.parents('.js-betslip-help').length > 0
    ) {
      return;
    }

    if (this.$el.hasClass('open')) {
      if (e.currentTarget.id !== 'betslip-footer') {
        this.closeBetslip();
        svs.events.publish('/betslip/close');
      }
    } else {
      this.openBetslip();
      svs.events.publish('/betslip/open');
    }
  },

  setWrapperPadding: function() {
    var $wrapper = $('.js-main-content');
    var $productBaseContent = $('.js-product-base-tabs-content');
    var padding;

    $wrapper.css('padding-bottom', '');

    padding =
      parseInt($wrapper.css('padding-bottom'), 10) +
      $('.betslip-footer').height();

    if ($productBaseContent.length === 0) {
      $wrapper.css('padding-bottom', padding);
    }
  },

  setHeight: function() {
    var betslipHeaderHeight = 41;
    var betslipPayfooter = 40;
    var headerHeight =
        svs.core.detect.formfactor.mobile() &&
          svs.core.detect.os.iOS() &&
          svs.core.detect.orientation.isLandscape() ?
          svs.components.header.getTopContentWrapperHeight() + 44 :
          svs.components.header.getTopContentWrapperHeight();
    var maxHeight = $(window).height() - headerHeight - 13; 
    var maxBetslipHeight = maxHeight - betslipHeaderHeight - betslipPayfooter;
    this.$el.find('.betslip-content-wrapper').css('maxHeight', maxHeight);
    this.$el.find('.betslip-content').css('maxHeight', maxBetslipHeight);
  },

  changeSize: function() {

    if (
      this.getRegion('betslipContent') &&
      this.getRegion('betslipContent').currentView
    ) {
      var newHeight = this.getRegion('betslipContent').currentView.$el[0]
        .clientHeight;
      var elementsMax = parseInt($('.betslip-content').css('max-height'), 10);
      var dynamicHeight = newHeight > elementsMax ? elementsMax : newHeight;
      if (newHeight <= elementsMax) {
        this.swiper && this.swiper.hideScroll(true);
      } else {
        this.swiper && this.swiper.hideScroll(false);
      }
      this.getRegion('betslipContent').$el.height(dynamicHeight);
    }
  },

  scrollTo: function(left, top, animationDuration) {
    if (this.swiper) {
      this.swiper.scrollTo(left, top, animationDuration);
    }
  },

  revalidateBetslip: function() {
    this.$el.toggleClass('invalid', !this.model.get('isValid'));
  },

  toggleNotification: function() {
    svs.components.animation.add(
      this.betslipNotificationEl,
      'animate-time-6ms betslip-notification-notify'
    );
  },

  validBetslip: function(options) {
    var self = this;

    if (options && options.open) {
      this.openBetslip();
    } else {
      setTimeout(function() {
        self.toggleNotification();
      }, 100);
    }

    if (options && options.tracking) {
      var evt = {
        category: 'Wager',
        action: 'Betslip Complete',
        opt_label: options.productName
      };

      svs.components.analytics.trackEvent(evt);
    }
  },
  getBetslipPosition: function() {
    this.overload.scrollContent
      .css({
        paddingBottom: '0px',
        marginBottom: '0'
      })
      .addClass('betslip-revealed');
    this.overload.betslipWrapper.css('position', 'relative');
    if (this.overload.actionbar) {
      this.overload.actionbar.css({
        position: 'relative',
        bottom: '0px'
      });
    }

    if (!this.overload.swiperContainer || this.overload.swiperContainer.length === 0) {
      this.overload.swiperContainer = $('.js-swiper-container');
    }

    this.overload.scrollContainerHeight = !svs.core.detect.formfactor.mobile() ?
      $(this.overload.swiperContainer)
        .has('#coupon')
        .height() :
      $(window).height();

    this.betslipPaymentArea.removeClass('hide').addClass('show');
    if (this.betslipPaymentArea.hasClass('show')) {
      this.overload.paymentAreaHeight = this.betslipPaymentArea.outerHeight();
    }
    if (this.overload.betslipPosition.length === 0) {
      this.overload.betslipPosition = $('.betslip-position-tag');
    }

    this.additionalScrollHeight();

    this.betslipPositionSet = true;
    this.betslipStickyBehaviour();
  },
  getActionbarHeight: function() {
    if (this.overload.actionbar) {
      if (this.overload.actionbar.is(':hidden')) {
        return 0;
      }
      return this.overload.actionbar.height() || 0;
    }
    return 0;
  },
  onScrollEvent: function(e) {
    this.scrollY = $(e.currentTarget).scrollTop();
    this.scrolling = true;
  },
  setWidth: function() {
    $('.betslip-wrapper, #betslip-footer').css('max-width', 'none');
    if (
      !svs.core.detect.formfactor.mobile() &&
      this.overload.betslipWrapper
    ) {
      this.overload.betslipWrapper.width(this.overload.scrollContent[0].clientWidth);
      this.overload.actionbar.width(this.overload.scrollContent[0].clientWidth);
    }
  },
  additionalScrollHeight: function() {
    if (svs.core.detect.formfactor.mobile()) {
      this.overload.scrollContainerHeight = window.innerHeight;
    }
    if ($('#coupon #betslip-wrapper').length) {
      this.overload.scrollContentHeight = this.overload.scrollContent.height() - this.overload.paymentAreaHeight;
    } else {
      this.overload.scrollContentHeight = this.overload.scrollContent.height();
    }
    this.overload.betslipOffsetTop = svs.core.detect.formfactor.mobile() ?
      this.overload.betslipPosition.offset().top :
      this.overload.betslipPosition[0].offsetTop - 44;

    this.overload.scrollHeight = this.overload.scrollContainerHeight - 44;
    if (this.overload.additionalScrollHeight) {
      this.overload.additionalScrollHeight(this);
    }
  },
  betslipStickyBehaviour: function() {
    var self = this;
    var actionbarHeight = self.getActionbarHeight();
    this.scrolling = false;
    this.scrollY = null;
    if (!this.onScrollBind) {
      this.onScrollBind = _.bind(this.onScrollEvent, this);
    }
    this.setWidth();

    if (this.betslipPositionSet) {
      this.betslipPositionSet = false;
      if (this.overload.scrollContentHeight > this.overload.scrollContainerHeight) {
        if (!svs.isBetslipLoaded) {
          this.betslipPaymentArea.removeClass('show').addClass('hide');
          this.setWidth();

          svs.components.animation.add(
            self.overload.betslipWrapper,
            'animate animate-from-bottom animate-time-short'
          );
          svs.isBetslipLoaded = true;
        }

        if (svs.core.detect.formfactor.mobile()) {
          $(window).off('scroll', this.onScrollBind);
          $(window).on('scroll', this.onScrollBind);
        } else {
          $(this.overload.swiperContainer)
            .has('#coupon')
            .off('scroll', this.onScrollBind);
          $(this.overload.swiperContainer)
            .has('#coupon')
            .on('scroll', this.onScrollBind);
        }

        this.betslipPaymentArea.removeClass('show').addClass('hide');
        this.overload.scrollContent
          .css({
            paddingBottom: self.overload.paymentAreaHeight + actionbarHeight,
            marginBottom: '44px'
          })
          .removeClass('betslip-revealed');
        this.overload.betslipWrapper.css('position', 'fixed');
        this.overload.actionbar.css({
          position: 'fixed',
          bottom: '44px',
          'z-index': '1091'
        });
        this.overload.scrollContent.removeClass('betslip-revealed');
      }

      clearInterval(self.scrollIntervalIndex);
      self.scrollIntervalIndex = setInterval(function() {
        if (self.scrolling) {
          var scrollOffset;
          self.scrolling = false;
          actionbarHeight = self.getActionbarHeight();

          if (svs.core.detect.formfactor.mobile()) {
            self.overload.betslipOffsetTop = self.overload.betslipPosition.offset().top;
          }
          self.additionalScrollHeight();

          scrollOffset = (
            self.overload.betslipOffsetTop +
            actionbarHeight -
            self.scrollY
          ).toFixed(0);

          if (scrollOffset <= self.overload.scrollHeight) {
            if (
              scrollOffset <=
              self.overload.scrollContainerHeight - (self.overload.paymentAreaHeight + 14)
            ) {
              self.overload.betslipWrapper.addClass('betslip-scrolled-to-bottom');
            } else {
              self.overload.betslipWrapper.removeClass('betslip-scrolled-to-bottom');
            }
            self.overload.betslipWrapper.css('position', 'relative');
            self.overload.actionbar.css({
              position: 'relative',
              bottom: '0px'
            });
            self.betslipPaymentArea.removeClass('hide').addClass('show');
            self.overload.scrollContent
              .css({
                paddingBottom: '0px',
                marginBottom: '0'
              })
              .addClass('betslip-revealed');
          } else {
            self.overload.betslipWrapper.css('position', 'fixed');
            self.overload.actionbar.css({
              position: 'fixed',
              bottom: '44px',
              'z-index': '1091'
            });
            self.betslipPaymentArea.removeClass('show').addClass('hide');
            self.overload.scrollContent
              .css({
                paddingBottom: self.overload.paymentAreaHeight + actionbarHeight,
                marginBottom: '44px'
              })
              .removeClass('betslip-revealed');
          }
        }
      }, 10);
    } else if (this.overload.betslipWrapper) {
      this.getBetslipPosition();
    }
  },

  scrollToBetslip: function() {
    this.overload.scrollToBetslip(this);
  },

  initRelativeBetslip: function() {
    this.overload.initRelativeBetslip(this);
    this.betslipPositionSet = false;
    this.betslipPaymentArea =
      this.overload.betslipPaymentArea ||
      this.getRegion('betslipPaymentArea').$el;
    this.betslipFooter = this.getRegion('betslipFooter').$el;
    this.betslipPaymentArea.removeClass('show').addClass('hide');
  },

  showOverview: function() {
    this.overload.showOverview(this);
    if (this.options.storeState) {
      svs.components.Storage.browser.set(
        this.options.storeState.type + 'betslipstate',
        this.options.storeState.product,
        {},
        svs.components.Storage.constants.EXPIRES_15M
      );
    }
    svs.components.analytics.trackVirtual('betslip');
  },

  openBetslip: function() {
    var jqContentWrapper;

    if (!(svs.components.marketplace &&
      svs.components.marketplace.accountSelector &&
      svs.components.marketplace.accountSelector.helpers.observer.getValue()
        .accounts.length > 0)) {
      this.hideBetslipTag();
    }

    this.$el.addClass('open');
    $(this.regions.betslipContent).removeClass('collapse');
    if (this.recycle) {
      jqContentWrapper = $(this.betslipContentWrapper);
      if (
        jqContentWrapper.css('top') === '0px' ||
        jqContentWrapper.css('top') === this.betslipHeaderHeight + 'px'
      ) {
        this.changeSize();
        jqContentWrapper.css(
          'top',
          this.getRegion('betslipContent').$el.height() +
          this.betslipHeaderHeight
        );
      }
      this.betslipContentWrapper.animate(
        { top: 0, useTranslate3d: true },
        this.animationSpeed,
        'easeOut'
      );
    }
    if (this.overload.openBetslip) {
      this.overload.openBetslip(this);
    }
    this.$el.on('touchmove', function(e) {
      var target = $(e.target);
      if (target.parents('.betslip-content').length === 0) {
        e.preventDefault();
      }
    });
    if (this.options.storeState) {
      svs.components.Storage.browser.set(
        this.options.storeState.type + 'betslipstate',
        this.options.storeState.product,
        {},
        svs.components.Storage.constants.EXPIRES_15M
      );
    }
    svs.components.analytics.trackVirtual('betslip');
  },

  closeBetslip: function() {
    svs.components.swiper.enableBodyScroll();

    var self = this;
    var betslipHeight;

    if (this.getRegion('betslipContent').$el) {
      betslipHeight = this.getRegion('betslipContent').$el.height() ?
        this.getRegion('betslipContent').$el.height() +
        this.betslipHeaderHeight :
        this.betslipHeaderHeight;
    } else {
      var betslipContentHeight = parseInt(window.getComputedStyle(this.el.querySelector('.betslip-content'))
        .height, 10);
      if (betslipContentHeight === 0) {
        betslipHeight = this.betslipHeaderHeight + 'px';
      } else {
        betslipHeight =
          betslipContentHeight + this.betslipHeaderHeight + 'px';
      }
    }

    if (self.$el.hasClass('open')) {
      svs.components.analytics.trackVirtual();
    }
    this.betslipContentWrapper.animate(
      { top: betslipHeight, useTranslate3d: true },
      this.animationSpeed,
      'easeIn',
      function() {
        self.$el.removeClass('open');

        if (svs.core.detect.formfactor.mobile()) {
          if (self.showActionbar) {
            $('#actionbar-content').show();
            self.showActionbar = false;
          }
        }

        window.requestIdleCallback(function() {
          if (!self.options.dontManipulateDOM && !self.recycle) {
            if (self.getRegion('betslipContent').$el) {
              self.getRegion('betslipContent').$el.html('');
            } else {
              self.el.querySelector('.betslip-content').innerHTML = '';
            }
          }

          if (self.overload && self.overload.closeBetslip) {
            self.overload.closeBetslip(self);
          }

          self.$el.off('touchmove');
        });
      }
    );
    if (this.options.storeState) {
      svs.components.Storage.browser.remove(
        this.options.storeState.type + 'betslipstate',
        this.options.storeState.product
      );
    }
  },

  collapseBetslip: function() {
    svs.components.swiper.enableBodyScroll();

    var $betslipContent = $(this.regions.betslipContent);
    if (this.$el.hasClass('open')) {
      svs.components.analytics.trackVirtual();
    }
    this.$el.removeClass('open');
    $betslipContent.addClass('collapse');
    $betslipContent.css('height', 0);

    this.overload.collapseBetslip(this);
  },

  hideBetslipTag: function() {
    var betslipFooterTag = $('.betslip-footer-tag');
    var border = $('.betslip-footer-border-override');

    if (betslipFooterTag.length > 0) {
      betslipFooterTag.addClass('hide');
      border.removeClass('betslip-border-syndicate');
    }
  },

  showBetslipTag: function(content) {
    var betslipFooterTag = $('.betslip-footer-tag');
    var border = $('.betslip-footer-border-override');

    if (betslipFooterTag.length > 0) {
      betslipFooterTag.removeClass('hide');
      border.addClass('betslip-border-syndicate');

      if (content && typeof content === 'string') {
        betslipFooterTag.text(content);
      }
    }
  },

  hideBetslip: function() {
    svs.components.swiper.enableBodyScroll();

    this.$el.hide();
  },

  showBetslip: function() {
    this.$el.show();
  }
});



 })(window);